export default __webpack_public_path__ + "static/Focus-35dc9aa62a8d0263bae916dc57ad2099.png";